import { render, staticRenderFns } from "./program-stats.vue?vue&type=template&id=a2f95114&"
import script from "./program-stats.vue?vue&type=script&lang=js&"
export * from "./program-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports